export const isWeb: boolean = typeof document !== 'undefined';
export const isMobile = !isWeb;